import {
  acExercicioLogado,
  findExerciciosByEntidade,
  loadExercicioPadrao
} from './entidades/Actions.js';

import AuthService from 'portaltransparencia-common/auth/AuthService.js';
import { fetchInfo } from 'portaltransparencia-common/info/Actions.js';

/* eslint-disable no-console */
export const fetchInitialState = async store => {
  const userInfo = AuthService.getUserInfo();

  await store.dispatch(fetchInfo());

  const entidadeFromURL = getSearchParams('entidade');

  if (entidadeFromURL) {
    console.log(`FETCH INITIAL STATE FROM URL: ENTIDADE:${entidadeFromURL}`);

    const { value } = await store.dispatch(
      findExerciciosByEntidade(entidadeFromURL)
    );

    if (value && value.length > 0) {
      await store.dispatch(
        acExercicioLogado(entidadeFromURL, value[0].id.exercicio)
      );
      return;
    }
    console.log(
      `FETCH INITIAL STATE FROM URL: ENTIDADE ${entidadeFromURL} NÃO POSSUÍ EXERCÍCIO`
    );
  }
  if (userInfo) {
    const { entidade, exercicio } = userInfo;

    console.log(
      `FETCH INITIAL STATE FROM STORAGE: ENTIDADE:${entidade.id} EXERCICIO:${exercicio.id}`
    );

    await store.dispatch(acExercicioLogado(entidade.id, exercicio.id));
  } else {
    console.log('FETCH ENTIDADE e EXERCICIO PADRÃO');
    await store.dispatch(loadExercicioPadrao());
  }
};

function getSearchParams(variable) {
  var query = window.location.search.substring(1);

  var params = query.split('&');

  for (var i = 0; i < params.length; i++) {
    var parametro = params[i].split('=');
    const parametroNome = parametro[0];
    const parametroValor = parametro[1];

    if (parametroNome == variable) {
      return parametroValor;
    }
  }
  return false;
}
/* eslint-enable no-console */
